export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '真相回旋镖的内容和普通爆料号有什么区别？',
    answer:
      '普通爆料号通常只发布“第一条”，我们更关注“后面发生了什么”。每条案例都会标注发布状态、信息来源和后续进展，并把澄清、更正、官方说明一并整理进时间线，方便你一次性看到完整走向。',
  },
  {
    question: '你们会直接下结论说某条爆料是真是假吗？',
    answer:
      '不会。我们只呈现可核实的事实与可追溯的来源，比如通告单、鉴定摘要、官方通报等。是否相信某条信息，最终由你自己判断。涉及尚未定论的内容，我们会明确标记为“澄清中”。',
  },
  {
    question: '为什么案例中的人物大多使用匿名表述？',
    answer:
      '因为绝大多数传闻在被证实之前都不该与具体个人绑定。匿名处理既能讲清事件的传播逻辑，也能避免对无关的人造成二次伤害。这也是我们内容原则里最重要的一条。',
  },
  {
    question: '发现案例内容有误，或者想补充后续进展，怎么联系你们？',
    answer:
      '可以通过关于我们页面提供的邮箱与我们联系，邮件里附上原始链接或可核对的材料即可。收到之后我们会重新核查，并在页面显著位置标注更正时间与更正内容。',
  },
  {
    question: '一条爆料从出现到澄清，一般要多久？',
    answer:
      '没有固定周期。简单的误会可能一天内就有说明，复杂的争议可能持续数月。我们的热度跟进时效是重大事件持续追踪，只要出现新的可核实材料，时间线就会同步更新。',
  },
  {
    question: '如何看待“反转”本身？反转会不会也是一种炒作？',
    answer:
      '确实有可能，所以我们不会把“反转”当成结论来追捧，而是把它当作一个新的、同样需要核实的信息。判断标准始终是材料和来源，而不是情绪上的胜负。',
  },
];